import { deserialize, identifier, serializable } from "serializr";
import { IJsonObject } from "../api";

interface IProps {
	id?: number;
	guid?: string;
	name?: string;
	type?: string;
}

export class Form {
	public static fromJson(json: IJsonObject): Form {
		return deserialize(Form, json);
	}

	public static fromJsonArray(json: IJsonObject[]): Form[] {
		return json.map((form: IJsonObject) => this.fromJson(form));
	}

	@serializable(identifier())
	public id: number | null;

	@serializable
	public guid: string;

	@serializable
	public name: string;

	@serializable
	public type: string;

	constructor({
		id = 0,
		guid = "",
		name = "",
		type = "courseware",
	}: IProps = {}) {
		this.id = id;
		this.guid = guid;
		this.name = name;
		this.type = type;
	}
}
